module.exports = __webpack_public_path__ + "static/4star-reveal-6d8d87689038b1ecfec23540fa8261ee.mp3";